import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { SharedService } from 'app/shared.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export interface IDerechosPaso {
    id: string;
    TipoDerechoDePaso: string;
    KilometrajePagado: string;
}

export interface ICarro {
    id: string;
    TipoCarro: string;
    MatriculaCarro: string;
    GuiaCarro: string;
    ToneladasNetasCarro: string;
}


@Component({
    selector: 'app-ferroviarios',
    templateUrl: './ferroviarios.component.html',
    styleUrls: ['./ferroviarios.component.scss']
})
export class FerroviariosComponent implements OnInit {
    @Input() idOperacion: any;
    @Input() idTransporteFerro: any;
    @Input() dataTransporteFerro: any;
    @Input() ferroviarios: any;
    @Output() saveFerroviario: EventEmitter<any> = new EventEmitter<any>();
    @Output() DelFerroviario: any = new EventEmitter<void>();
    @Output() resetFormulario: any = new EventEmitter<void>();

    FormTransporte = new FormGroup({
        ferroviario: new FormControl(''),
        servicio: new FormControl('', [Validators.required]),
        nombre: new FormControl(''),
        poliza: new FormControl(''),
        concecionario: new FormControl(''),
        datosPaso: new FormControl(null, [Validators.required]),
        datosCarro: new FormControl(null, [Validators.required])
    });

    countDerechosPaso: any = [];
    removeDisabledDP: boolean = true;

    countCarro: any = [];
    removeDisabledCarro: boolean = true;

    lstDerechosPaso: IDerechosPaso[] = []
    lstCarro: ICarro[] = []


    opcionesFiltradasServicios: Observable<any[]>;
    lstServicios: any;

    idEmpresa: number;
    idFerroviario: number;

    constructor(
        private sharedService: SharedService,
        private srvcoal: CoalService
    ) {

    }

    ngOnInit(): void {
        // this.SelFerroviarios()
        this.GetServicios()
        this.FormTransporte.valueChanges.subscribe(changes => {
            if (this.FormTransporte.valid) {
                this.sharedService.setFormFerroviarios(changes);
            }
        });

        this.sharedService.ferroPasoForm$.subscribe(valores => {
            const index = this.lstDerechosPaso.findIndex(item => item && item.id === valores.id);
            if (index === -1) {
                if (valores) this.lstDerechosPaso.push(valores);
            } else {
                if (valores) this.lstDerechosPaso[index] = valores;
            }
            this.FormTransporte.controls.datosPaso.setValue(this.lstDerechosPaso);
        });

        this.sharedService.ferroCarroForm$.subscribe(valores => {
            // console.log('ferroCarroForm$', valores)
            const index = this.lstCarro.findIndex(item => item && item.id === valores.id);
            if (index === -1) {
                if (valores) this.lstCarro.push(valores);
            } else {
                if (valores) this.lstCarro[index] = valores;
            }
            this.FormTransporte.controls.datosCarro.setValue(this.lstCarro);
        });

        if (this.idTransporteFerro) {
            console.log('Es actualizacion', this.dataTransporteFerro)
            // datoPaso
            this.FormTransporte.patchValue({
                servicio: this.dataTransporteFerro.servicio,
                nombre: this.dataTransporteFerro.nombre,
                poliza: this.dataTransporteFerro.poliza,
                concecionario: this.dataTransporteFerro.concecionario
            });

            // this.dataDerechoPaso = 
        }
    }

    //Agregar formulario
    addDerechosPaso = () => {
        this.countDerechosPaso.push({ id: `DerechosPaso${this.countDerechosPaso.length + 1}` });
        this.countDerechosPaso.length <= 0 ? this.removeDisabledDP = true : this.removeDisabledDP = false;
    };

    //Remover formulario
    removeDerechosPaso = () => {
        localStorage.removeItem('DerechosPaso' + this.countDerechosPaso.length);
        this.countDerechosPaso.splice(-1);
        this.countDerechosPaso.length <= 0 ? this.removeDisabledDP = true : this.removeDisabledDP = false;
    };



    //Agregar formulario
    addCarro = () => {
        this.countCarro.push({ id: `Carro${this.countCarro.length + 1}` });
        this.countCarro.length <= 0 ? this.removeDisabledCarro = true : this.removeDisabledCarro = false;
    };

    //Remover formulario
    removeCarro = () => {
        localStorage.removeItem('Carro' + this.countCarro.length);
        this.countCarro.splice(-1);
        this.countCarro.length <= 0 ? this.removeDisabledCarro = true : this.removeDisabledCarro = false;
    };

    asingdataForm(value) {
        if (value == '0') {
            this.resetFormulario.emit(this.FormTransporte)
            this.FormTransporte.reset();
            this.countDerechosPaso = [];
            this.countCarro = [];
            this.idFerroviario = undefined
            return
        }
        this.idFerroviario = value.id;

        // this.FormTransporte.controls.ferroviario.setValue(value.id);
        this.FormTransporte.controls.servicio.setValue(value.attributes.cat_tipo_servicio.data ? value.attributes.cat_tipo_servicio.data.id : null);
        this.FormTransporte.controls.nombre.setValue(value.attributes.nombreAseg);
        this.FormTransporte.controls.poliza.setValue(value.attributes.numPolizaSeguro);
        this.FormTransporte.controls.concecionario.setValue(value.attributes.Concesionario);

        this.selExtras(value);


    }

    selExtras(mercancia) {

        this.asignarExtrasPaso(mercancia.attributes.fac_porte_derechos);
        this.asignarExtrasCarro(mercancia.attributes.fac_porte_carros);

    }

    asignarExtrasPaso(data) {
        this.countDerechosPaso = [];
        const sortedData = data.data.sort((a, b) => a.id - b.id);
        for (var i = 0; i <= sortedData.length - 1; i++) {
            let datos = {
                TipoDerechoDePaso: sortedData[i].attributes.cat_tipo_derecho_paso.data.id,
                KilometrajePagado: sortedData[i].attributes.KilometrajePagado
            }
            this.countDerechosPaso.push({ id: `DerechosPaso ` + (i + 1), data: datos });
        }
    }

    asignarExtrasCarro(data) {
        this.countCarro = [];
        const sortedData = data.data.sort((a, b) => a.id - b.id);

        for (var i = 0; i <= sortedData.length - 1; i++) {
            let datos = {
                TipoCarro: sortedData[i].attributes.cat_tipo_carro.data.id,
                MatriculaCarro: sortedData[i].attributes.matriculaCarro,
                GuiaCarro: sortedData[i].attributes.guiaCarro,
                ToneladasNetasCarro: sortedData[i].attributes.toneladasNetasCarro,
                Contenedor: sortedData[i].attributes.fac_porte_contenedor.data
            }
            this.countCarro.push({ id: `Carro ` + (i + 1), data: datos });
        }
    }

    GuardaFormulario() {
        this.saveFerroviario.emit({ formTransporte: this.FormTransporte, idFerroviario: this.idFerroviario });
      }


    EliminarFerroviario() {
        this.DelFerroviario.emit(this.idFerroviario)
        this.FormTransporte.reset();
        this.countDerechosPaso = [];
        this.countCarro = [];



    }

    GetServicios() {
        this.srvcoal.getService(`cat-tipo-servicios`,).subscribe((res: any) => {
            if (res.err) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                // this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.lstServicios = res.data;
                this.opcionesFiltradasServicios = this.FormTransporte.get('servicio').valueChanges.pipe(
                    startWith(''),
                    map(state => (state ? this._filtrarServicios(state) : this.lstServicios)),
                );


            }
            // this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            // this.store.dispatch(OcultarSpinner())
        });
    }

    private _filtrarServicios(value: any): any[] {
        const filterValue = value?.toLowerCase();

        return this.lstServicios.filter(unidad =>
        (unidad.attributes.clave.toLowerCase().includes(filterValue) ||
            unidad.attributes.tipoServicio.toLowerCase().includes(filterValue))
        );
    }

    displayServicio = (bienes: any): string => {
        const servicioEncontrado = this.lstServicios.find((f: any) => f.id === bienes);
        if (servicioEncontrado) {
            return `${servicioEncontrado.attributes.clave} - ${servicioEncontrado.attributes.tipoServicio}`;
        } else {
            return '';
        }
    }

    AsignarValor(valor: any) {
        console.log(valor)
        this.FormTransporte.controls.ferroviario.setValue(valor.id);
        this.asingdataForm(valor);
    }



}
